// 导出axios实例
import axios from './axios'

// 导出请求方法
import { get, post, put, del, patch, upload, download } from './request'
import request from './request'
const url = 'https://xiaolu-pm.oss-cn-hangzhou.aliyuncs.com/xiaolu-website'


// 统一导出
export {
  axios,
  get,
  post,
  put,
  del,
  patch,
  upload,
  download,
  request,
  url

}